import {EventFlowContainer} from './event-flow-container';

export default {
    component: EventFlowContainer
};
